export enum FEATURES {
  NEWS = "news"
}
